const MODES = [
  { key: 'lowest',      label: 'Lowest',      color: '#0C447C' },
  { key: 'Coles',       label: 'Coles',       color: '#E50016' },
  { key: 'Woolworths',  label: 'Woolworths',  color: '#129C4F' },
  { key: 'Aldi',        label: 'Aldi',        color: '#001E5E' },
  { key: 'all',         label: 'Compare all', color: '#6366f1' },
];

export default function PriceModeSelector({ mode, onChange }) {
  return (
    <div className="pms-wrap">
      <span className="pms-label">Show prices:</span>
      <div className="pms-pills">
        {MODES.map(m => (
          <button
            key={m.key}
            className={`pms-pill ${mode === m.key ? 'pms-pill--active' : ''}`}
            style={{ '--pms-color': m.color }}
            onClick={() => onChange(m.key)}
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  );
}
